const bbStyle = {
    borderBottomColor: "grey.300",
    borderBottomStyle: "solid",
  };
  
  const bb1Style = {
    borderBottomWidth: 1,
    ...bbStyle,
  };
  
  const bb2Style = {
    borderBottomWidth: 2,
    ...bbStyle,
  };
  
  const bb3Style = {
    borderBottomWidth: 3,
    ...bbStyle,
  };
  
  const btStyle = {
    borderTopColor: "grey.300",
    borderTopStyle: "solid",
  };
  
  const bt1Style = {
    borderTopWidth: 1,
    ...btStyle,
  };
  
  const bt2Style = {
    borderTopWidth: 2,
    ...btStyle,
  };
  
  const bt3Style = {
    borderTopWidth: 3,
    ...btStyle,
  };

  export {bbStyle, bb1Style, bb2Style, bb3Style, btStyle, bt1Style, bt2Style, bt3Style}